export enum ConfigurationKey {
  Locales = "LOCALES",
  DefaultLocale = "DEFAULT_LOCALE",
  LocaleQueryKey = "LOCALE_QUERY_KEY",
  KofiUrl = "KOFI_URL",
}
